import {Injectable} from '@angular/core';
import {catchError, firstValueFrom, map, Observable, of, tap} from 'rxjs';
import {DashboardGridInputs} from 'src/app/models/dashboard/datagrid-input';
import {ListDto} from 'src/app/pages/scenario/adjustment/adjustment.service';
import { BaseService } from 'src/app/services/base.service';

@Injectable({
	providedIn: 'root',
})

export class DashboardBIService {
	constructor(private readonly baseService: BaseService) { }

	deleteDashboard(dashboardId: string): Observable<Object> {
		let url = `DashboardCrud/DeleteDashboardData?id=${dashboardId}`;

		return this.baseService.post(url);
	}

	saveDataGridData(inputData: DashboardGridInputs): Observable<Object> {
		let url = 'DashboardCrud/GridSaveInputs';

		return this.baseService.post(
			url,
			inputData,
		);
	}

	private lstGridData: ListDto[] = [];
	async dashboardGridConfiguration(): Promise<ListDto[]> {
		if (this.lstGridData && this.lstGridData.length > 0) {
			return this.lstGridData;
		}

		const url = 'DashboardCrud/SelectDashboardSettings';
		const fetchedData: ListDto[] = await firstValueFrom(this.baseService.get<ListDto[]>(url));
		this.lstGridData = fetchedData;

		return fetchedData;
	}

	private lstDropDownGridData: ListDto[] = [];

	dashboardGridDropdownData(listIds: number[]): Observable<ListDto[]> {
		// Check if listIds is null or empty
		if (!listIds || listIds.length === 0) {
			return of([]); // Return an Observable with empty array
		}

		// Get all existing listIds from lstDropDownGridData
		const existingListIds = this.lstDropDownGridData.map((item) => item.listId);

		// Find listIds that don't exist in lstDropDownGridData
		const missingListIds = listIds.filter((id) => !existingListIds.includes(id));

		// If no missing IDs, return filtered existing data
		if (!missingListIds || missingListIds.length === 0) {
			return of(this.lstDropDownGridData.filter((item) => listIds.includes(item.listId)));
		}

		// Fetch missing data
		const url = 'DashboardCrud/dashboardGridDropdownData';

		return this.baseService.post<ListDto[]>(
			url,
			missingListIds,
		).pipe(
			tap((fetchedData: ListDto[]) => {
				// Merge new data with existing data, avoiding duplicates
				if (fetchedData && fetchedData.length > 0) {
					const uniqueNewData = fetchedData.filter(
						(newItem) => !this.lstDropDownGridData.some(
							(existingItem) => existingItem.listId === newItem.listId,
						),
					);

					// Add to existing array
					this.lstDropDownGridData.push(...uniqueNewData);
				}
			}),
			map(() => {
				// Return only the items that were requested (both existing and new)
				// console.error('Error fetching dropdown data:', this.lstDropDownGridData.filter(item => listIds.includes(item.listId)));
				return this.lstDropDownGridData.filter((item) => listIds.includes(item.listId));
			}),
			catchError((error) => {
				console.error(
					'Error fetching dropdown data:',
					error,
				);

				// Return filtered existing data even if fetch fails
				return of(this.lstDropDownGridData.filter((item) => listIds.includes(item.listId)));
			}),
		);
	}

	private lstDynamicUpdateObject: ListDto[] = [];
	async LoadDynamicUpdateObject(): Promise<ListDto[]> {
		if (this.lstDynamicUpdateObject && this.lstDynamicUpdateObject.length > 0) {
			return this.lstDynamicUpdateObject;
		}

		const url = 'DashboardCrud/SelectDashboardUpdateObjectSettings';
		const fetchedData: ListDto[] = await firstValueFrom(this.baseService.get<ListDto[]>(url));
		this.lstDynamicUpdateObject = fetchedData;

		return fetchedData;
	}
}